var map = {
	"./af-NA/territories.json": [
		83211,
		83211
	],
	"./af/territories.json": [
		99753,
		99753
	],
	"./agq/territories.json": [
		92515,
		92515
	],
	"./ak/territories.json": [
		46106,
		46106
	],
	"./am/territories.json": [
		94144,
		94144
	],
	"./ar-AE/territories.json": [
		27736,
		27736
	],
	"./ar-BH/territories.json": [
		77048,
		77048
	],
	"./ar-DJ/territories.json": [
		69748,
		69748
	],
	"./ar-DZ/territories.json": [
		47076,
		47076
	],
	"./ar-EG/territories.json": [
		40226,
		40226
	],
	"./ar-EH/territories.json": [
		92099,
		92099
	],
	"./ar-ER/territories.json": [
		98553,
		98553
	],
	"./ar-IL/territories.json": [
		1995,
		1995
	],
	"./ar-IQ/territories.json": [
		77228,
		77228
	],
	"./ar-JO/territories.json": [
		67101,
		67101
	],
	"./ar-KM/territories.json": [
		96410,
		96410
	],
	"./ar-KW/territories.json": [
		70484,
		70484
	],
	"./ar-LB/territories.json": [
		25780,
		25780
	],
	"./ar-LY/territories.json": [
		32077,
		32077
	],
	"./ar-MA/territories.json": [
		68496,
		68496
	],
	"./ar-MR/territories.json": [
		33569,
		33569
	],
	"./ar-OM/territories.json": [
		56982,
		56982
	],
	"./ar-PS/territories.json": [
		23595,
		23595
	],
	"./ar-QA/territories.json": [
		79940,
		79940
	],
	"./ar-SA/territories.json": [
		87822,
		87822
	],
	"./ar-SD/territories.json": [
		95837,
		95837
	],
	"./ar-SO/territories.json": [
		83188,
		83188
	],
	"./ar-SS/territories.json": [
		97184,
		97184
	],
	"./ar-SY/territories.json": [
		36998,
		36998
	],
	"./ar-TD/territories.json": [
		44638,
		44638
	],
	"./ar-TN/territories.json": [
		7496,
		7496
	],
	"./ar-YE/territories.json": [
		37168,
		37168
	],
	"./ar/territories.json": [
		59653,
		59653
	],
	"./as/territories.json": [
		46866,
		46866
	],
	"./asa/territories.json": [
		37639,
		37639
	],
	"./ast/territories.json": [
		5163,
		27544
	],
	"./az-Arab-IQ/territories.json": [
		18165,
		18165
	],
	"./az-Arab-TR/territories.json": [
		38309,
		38309
	],
	"./az-Arab/territories.json": [
		6954,
		6954
	],
	"./az-Cyrl/territories.json": [
		23284,
		23284
	],
	"./az-Latn/territories.json": [
		23807,
		23807
	],
	"./az/territories.json": [
		92797,
		92797
	],
	"./bas/territories.json": [
		10250,
		10250
	],
	"./be-tarask/territories.json": [
		89564,
		89564
	],
	"./be/territories.json": [
		27231,
		27231
	],
	"./bem/territories.json": [
		81812,
		81812
	],
	"./bez/territories.json": [
		85417,
		85417
	],
	"./bg/territories.json": [
		28621,
		28621
	],
	"./bgc/territories.json": [
		1644,
		1644
	],
	"./bgn-AE/territories.json": [
		35922,
		35922
	],
	"./bgn-AF/territories.json": [
		36183,
		36183
	],
	"./bgn-IR/territories.json": [
		56483,
		56483
	],
	"./bgn-OM/territories.json": [
		46124,
		46124
	],
	"./bgn/territories.json": [
		84379,
		84379
	],
	"./bho/territories.json": [
		5823,
		5823
	],
	"./blo/territories.json": [
		76699,
		76699
	],
	"./bm/territories.json": [
		58695,
		58695
	],
	"./bn-IN/territories.json": [
		82536,
		82536
	],
	"./bn/territories.json": [
		72546,
		72546
	],
	"./bo-IN/territories.json": [
		86457,
		86457
	],
	"./bo/territories.json": [
		87541,
		87541
	],
	"./br/territories.json": [
		54862,
		54862
	],
	"./brx/territories.json": [
		7504,
		7504
	],
	"./bs-Cyrl/territories.json": [
		80480,
		80480
	],
	"./bs-Latn/territories.json": [
		97467,
		97467
	],
	"./bs/territories.json": [
		44113,
		44113
	],
	"./bss/territories.json": [
		41416,
		41416
	],
	"./ca-AD/territories.json": [
		69274,
		69274
	],
	"./ca-ES-valencia/territories.json": [
		10543,
		10543
	],
	"./ca-FR/territories.json": [
		18895,
		18895
	],
	"./ca-IT/territories.json": [
		14242,
		14242
	],
	"./ca/territories.json": [
		10158,
		10158
	],
	"./ccp-IN/territories.json": [
		71276,
		71276
	],
	"./ccp/territories.json": [
		64782,
		64782
	],
	"./ce/territories.json": [
		22314,
		22314
	],
	"./ceb/territories.json": [
		1930,
		1930
	],
	"./cgg/territories.json": [
		94635,
		94635
	],
	"./cho/territories.json": [
		34196,
		34196
	],
	"./chr/territories.json": [
		45219,
		45219
	],
	"./cic/territories.json": [
		14017,
		14017
	],
	"./ckb-IR/territories.json": [
		96130,
		96130
	],
	"./ckb/territories.json": [
		75000,
		75000
	],
	"./cs/territories.json": [
		57376,
		57376
	],
	"./csw/territories.json": [
		65311,
		65311
	],
	"./cv/territories.json": [
		82527,
		82527
	],
	"./cy/territories.json": [
		36134,
		36134
	],
	"./da-GL/territories.json": [
		98937,
		98937
	],
	"./da/territories.json": [
		94765,
		94765
	],
	"./dav/territories.json": [
		96867,
		96867
	],
	"./de-AT/territories.json": [
		59679,
		59679
	],
	"./de-BE/territories.json": [
		91747,
		91747
	],
	"./de-CH/territories.json": [
		49861,
		49861
	],
	"./de-IT/territories.json": [
		43831,
		43831
	],
	"./de-LI/territories.json": [
		27073,
		27073
	],
	"./de-LU/territories.json": [
		26341,
		26341
	],
	"./de/territories.json": [
		23585,
		23585
	],
	"./dje/territories.json": [
		10353,
		10353
	],
	"./doi/territories.json": [
		34220,
		34220
	],
	"./dsb/territories.json": [
		14977,
		14977
	],
	"./dua/territories.json": [
		69462,
		69462
	],
	"./dyo/territories.json": [
		38384,
		38384
	],
	"./dz/territories.json": [
		4820,
		4820
	],
	"./ebu/territories.json": [
		47194,
		47194
	],
	"./ee-TG/territories.json": [
		66944,
		66944
	],
	"./ee/territories.json": [
		60116,
		60116
	],
	"./el-CY/territories.json": [
		70296,
		70296
	],
	"./el-polyton/territories.json": [
		69405,
		69405
	],
	"./el/territories.json": [
		89423,
		89423
	],
	"./en-001/territories.json": [
		54187,
		54187
	],
	"./en-150/territories.json": [
		56462,
		56462
	],
	"./en-AE/territories.json": [
		9680,
		9680
	],
	"./en-AG/territories.json": [
		10638,
		10638
	],
	"./en-AI/territories.json": [
		39604,
		39604
	],
	"./en-AS/territories.json": [
		51898,
		51898
	],
	"./en-AT/territories.json": [
		37955,
		37955
	],
	"./en-AU/territories.json": [
		94336,
		94336
	],
	"./en-BB/territories.json": [
		80966,
		80966
	],
	"./en-BE/territories.json": [
		98599,
		98599
	],
	"./en-BI/territories.json": [
		93891,
		93891
	],
	"./en-BM/territories.json": [
		35007,
		35007
	],
	"./en-BS/territories.json": [
		16793,
		16793
	],
	"./en-BW/territories.json": [
		901,
		901
	],
	"./en-BZ/territories.json": [
		34126,
		34126
	],
	"./en-CA/territories.json": [
		34230,
		34230
	],
	"./en-CC/territories.json": [
		34296,
		34296
	],
	"./en-CH/territories.json": [
		85553,
		85553
	],
	"./en-CK/territories.json": [
		336,
		336
	],
	"./en-CM/territories.json": [
		28810,
		28810
	],
	"./en-CX/territories.json": [
		56929,
		56929
	],
	"./en-CY/territories.json": [
		2750,
		2750
	],
	"./en-DE/territories.json": [
		91657,
		91657
	],
	"./en-DG/territories.json": [
		41579,
		41579
	],
	"./en-DK/territories.json": [
		26463,
		26463
	],
	"./en-DM/territories.json": [
		45953,
		45953
	],
	"./en-Dsrt/territories.json": [
		50173,
		50173
	],
	"./en-ER/territories.json": [
		49809,
		49809
	],
	"./en-FI/territories.json": [
		11255,
		11255
	],
	"./en-FJ/territories.json": [
		18994,
		18994
	],
	"./en-FK/territories.json": [
		48133,
		48133
	],
	"./en-FM/territories.json": [
		50235,
		50235
	],
	"./en-GB/territories.json": [
		12063,
		12063
	],
	"./en-GD/territories.json": [
		12097,
		12097
	],
	"./en-GG/territories.json": [
		33120,
		33120
	],
	"./en-GH/territories.json": [
		277,
		277
	],
	"./en-GI/territories.json": [
		63714,
		63714
	],
	"./en-GM/territories.json": [
		16006,
		16006
	],
	"./en-GU/territories.json": [
		49422,
		49422
	],
	"./en-GY/territories.json": [
		44786,
		44786
	],
	"./en-HK/territories.json": [
		58803,
		58803
	],
	"./en-ID/territories.json": [
		31467,
		31467
	],
	"./en-IE/territories.json": [
		50728,
		50728
	],
	"./en-IL/territories.json": [
		87971,
		87971
	],
	"./en-IM/territories.json": [
		48736,
		48736
	],
	"./en-IN/territories.json": [
		12065,
		12065
	],
	"./en-IO/territories.json": [
		41534,
		41534
	],
	"./en-JE/territories.json": [
		87628,
		65247
	],
	"./en-JM/territories.json": [
		13063,
		13063
	],
	"./en-KE/territories.json": [
		60330,
		60330
	],
	"./en-KI/territories.json": [
		56374,
		56374
	],
	"./en-KN/territories.json": [
		78263,
		78263
	],
	"./en-KY/territories.json": [
		90502,
		90502
	],
	"./en-LC/territories.json": [
		67103,
		67103
	],
	"./en-LR/territories.json": [
		70636,
		70636
	],
	"./en-LS/territories.json": [
		12559,
		12559
	],
	"./en-MG/territories.json": [
		13074,
		13074
	],
	"./en-MH/territories.json": [
		6963,
		6963
	],
	"./en-MO/territories.json": [
		34570,
		34570
	],
	"./en-MP/territories.json": [
		37099,
		37099
	],
	"./en-MS/territories.json": [
		166,
		166
	],
	"./en-MT/territories.json": [
		33351,
		33351
	],
	"./en-MU/territories.json": [
		60932,
		60932
	],
	"./en-MV/territories.json": [
		31093,
		31093
	],
	"./en-MW/territories.json": [
		91554,
		91554
	],
	"./en-MY/territories.json": [
		76704,
		76704
	],
	"./en-NA/territories.json": [
		88999,
		88999
	],
	"./en-NF/territories.json": [
		10086,
		10086
	],
	"./en-NG/territories.json": [
		81993,
		81993
	],
	"./en-NL/territories.json": [
		43552,
		43552
	],
	"./en-NR/territories.json": [
		38866,
		38866
	],
	"./en-NU/territories.json": [
		27579,
		27579
	],
	"./en-NZ/territories.json": [
		4650,
		4650
	],
	"./en-PG/territories.json": [
		77359,
		77359
	],
	"./en-PH/territories.json": [
		18998,
		18998
	],
	"./en-PK/territories.json": [
		45563,
		45563
	],
	"./en-PN/territories.json": [
		44756,
		44756
	],
	"./en-PR/territories.json": [
		74368,
		74368
	],
	"./en-PW/territories.json": [
		83167,
		83167
	],
	"./en-RW/territories.json": [
		93717,
		93717
	],
	"./en-SB/territories.json": [
		65163,
		65163
	],
	"./en-SC/territories.json": [
		49640,
		49640
	],
	"./en-SD/territories.json": [
		56981,
		56981
	],
	"./en-SE/territories.json": [
		20418,
		20418
	],
	"./en-SG/territories.json": [
		18628,
		18628
	],
	"./en-SH/territories.json": [
		7534,
		85153
	],
	"./en-SI/territories.json": [
		86782,
		86782
	],
	"./en-SL/territories.json": [
		71629,
		71629
	],
	"./en-SS/territories.json": [
		41528,
		41528
	],
	"./en-SX/territories.json": [
		93393,
		93393
	],
	"./en-SZ/territories.json": [
		60211,
		60211
	],
	"./en-TC/territories.json": [
		46743,
		46743
	],
	"./en-TK/territories.json": [
		63503,
		63503
	],
	"./en-TO/territories.json": [
		15507,
		15507
	],
	"./en-TT/territories.json": [
		44358,
		44358
	],
	"./en-TV/territories.json": [
		4936,
		4936
	],
	"./en-TZ/territories.json": [
		6396,
		6396
	],
	"./en-UG/territories.json": [
		40650,
		40650
	],
	"./en-UM/territories.json": [
		33652,
		33652
	],
	"./en-VC/territories.json": [
		39693,
		39693
	],
	"./en-VG/territories.json": [
		41441,
		41441
	],
	"./en-VI/territories.json": [
		69767,
		69767
	],
	"./en-VU/territories.json": [
		38355,
		38355
	],
	"./en-WS/territories.json": [
		31932,
		31932
	],
	"./en-ZA/territories.json": [
		54291,
		54291
	],
	"./en-ZM/territories.json": [
		85527,
		85527
	],
	"./en-ZW/territories.json": [
		82061,
		82061
	],
	"./en/territories.json": [
		86493,
		86493
	],
	"./eo/territories.json": [
		50762,
		50762
	],
	"./es-419/territories.json": [
		77601,
		77601
	],
	"./es-AR/territories.json": [
		55784,
		55784
	],
	"./es-BO/territories.json": [
		96116,
		96116
	],
	"./es-BR/territories.json": [
		93187,
		93187
	],
	"./es-BZ/territories.json": [
		70507,
		70507
	],
	"./es-CL/territories.json": [
		55396,
		55396
	],
	"./es-CO/territories.json": [
		25557,
		25557
	],
	"./es-CR/territories.json": [
		45454,
		45454
	],
	"./es-CU/territories.json": [
		62319,
		62319
	],
	"./es-DO/territories.json": [
		9706,
		9706
	],
	"./es-EA/territories.json": [
		58765,
		58765
	],
	"./es-EC/territories.json": [
		55903,
		55903
	],
	"./es-GQ/territories.json": [
		36119,
		36119
	],
	"./es-GT/territories.json": [
		16920,
		16920
	],
	"./es-HN/territories.json": [
		21849,
		21849
	],
	"./es-IC/territories.json": [
		43651,
		43651
	],
	"./es-MX/territories.json": [
		73898,
		73898
	],
	"./es-NI/territories.json": [
		38658,
		38658
	],
	"./es-PA/territories.json": [
		50580,
		50580
	],
	"./es-PE/territories.json": [
		40664,
		40664
	],
	"./es-PH/territories.json": [
		7343,
		7343
	],
	"./es-PR/territories.json": [
		56117,
		56117
	],
	"./es-PY/territories.json": [
		50236,
		50236
	],
	"./es-SV/territories.json": [
		3418,
		3418
	],
	"./es-US/territories.json": [
		37439,
		37439
	],
	"./es-UY/territories.json": [
		97749,
		97749
	],
	"./es-VE/territories.json": [
		26982,
		26982
	],
	"./es/territories.json": [
		58214,
		58214
	],
	"./et/territories.json": [
		75847,
		75847
	],
	"./eu/territories.json": [
		31556,
		31556
	],
	"./ewo/territories.json": [
		60337,
		60337
	],
	"./fa-AF/territories.json": [
		22971,
		22971
	],
	"./fa/territories.json": [
		50983,
		50983
	],
	"./ff-Adlm-BF/territories.json": [
		55594,
		55594
	],
	"./ff-Adlm-CM/territories.json": [
		98562,
		98562
	],
	"./ff-Adlm-GH/territories.json": [
		97005,
		97005
	],
	"./ff-Adlm-GM/territories.json": [
		95806,
		95806
	],
	"./ff-Adlm-GW/territories.json": [
		50552,
		50552
	],
	"./ff-Adlm-LR/territories.json": [
		97604,
		97604
	],
	"./ff-Adlm-MR/territories.json": [
		17601,
		17601
	],
	"./ff-Adlm-NE/territories.json": [
		82051,
		82051
	],
	"./ff-Adlm-NG/territories.json": [
		51393,
		51393
	],
	"./ff-Adlm-SL/territories.json": [
		63077,
		63077
	],
	"./ff-Adlm-SN/territories.json": [
		26199,
		26199
	],
	"./ff-Adlm/territories.json": [
		92421,
		92421
	],
	"./ff-Latn-BF/territories.json": [
		69007,
		69007
	],
	"./ff-Latn-CM/territories.json": [
		73479,
		73479
	],
	"./ff-Latn-GH/territories.json": [
		53788,
		53788
	],
	"./ff-Latn-GM/territories.json": [
		58691,
		58691
	],
	"./ff-Latn-GN/territories.json": [
		65150,
		65150
	],
	"./ff-Latn-GW/territories.json": [
		31609,
		31609
	],
	"./ff-Latn-LR/territories.json": [
		8817,
		8817
	],
	"./ff-Latn-MR/territories.json": [
		34516,
		34516
	],
	"./ff-Latn-NE/territories.json": [
		71070,
		71070
	],
	"./ff-Latn-NG/territories.json": [
		79872,
		79872
	],
	"./ff-Latn-SL/territories.json": [
		17396,
		17396
	],
	"./ff-Latn/territories.json": [
		9062,
		9062
	],
	"./ff/territories.json": [
		72070,
		72070
	],
	"./fi/territories.json": [
		68127,
		68127
	],
	"./fil/territories.json": [
		29783,
		29783
	],
	"./fo-DK/territories.json": [
		90779,
		90779
	],
	"./fo/territories.json": [
		68161,
		68161
	],
	"./fr-BE/territories.json": [
		98638,
		98638
	],
	"./fr-BF/territories.json": [
		87411,
		87411
	],
	"./fr-BI/territories.json": [
		28466,
		28466
	],
	"./fr-BJ/territories.json": [
		28727,
		28727
	],
	"./fr-BL/territories.json": [
		3513,
		3513
	],
	"./fr-CA/territories.json": [
		15711,
		15711
	],
	"./fr-CD/territories.json": [
		90560,
		90560
	],
	"./fr-CF/territories.json": [
		81758,
		81758
	],
	"./fr-CG/territories.json": [
		35201,
		35201
	],
	"./fr-CH/territories.json": [
		38276,
		38276
	],
	"./fr-CI/territories.json": [
		47175,
		47175
	],
	"./fr-CM/territories.json": [
		30827,
		30827
	],
	"./fr-DJ/territories.json": [
		15829,
		15829
	],
	"./fr-DZ/territories.json": [
		26949,
		26949
	],
	"./fr-GA/territories.json": [
		699,
		699
	],
	"./fr-GF/territories.json": [
		53106,
		53106
	],
	"./fr-GN/territories.json": [
		74602,
		74602
	],
	"./fr-GP/territories.json": [
		93832,
		93832
	],
	"./fr-GQ/territories.json": [
		77131,
		77131
	],
	"./fr-HT/territories.json": [
		67511,
		67511
	],
	"./fr-KM/territories.json": [
		81491,
		81491
	],
	"./fr-LU/territories.json": [
		65531,
		87912
	],
	"./fr-MA/territories.json": [
		61129,
		61129
	],
	"./fr-MC/territories.json": [
		15915,
		15915
	],
	"./fr-MF/territories.json": [
		56100,
		56100
	],
	"./fr-MG/territories.json": [
		28519,
		28519
	],
	"./fr-ML/territories.json": [
		7482,
		7482
	],
	"./fr-MQ/territories.json": [
		61401,
		61401
	],
	"./fr-MR/territories.json": [
		90648,
		90648
	],
	"./fr-MU/territories.json": [
		21029,
		21029
	],
	"./fr-NC/territories.json": [
		37984,
		37984
	],
	"./fr-NE/territories.json": [
		75770,
		75770
	],
	"./fr-PF/territories.json": [
		78381,
		78381
	],
	"./fr-PM/territories.json": [
		88964,
		88964
	],
	"./fr-RE/territories.json": [
		91134,
		91134
	],
	"./fr-RW/territories.json": [
		25872,
		25872
	],
	"./fr-SC/territories.json": [
		42333,
		42333
	],
	"./fr-SN/territories.json": [
		46774,
		46774
	],
	"./fr-SY/territories.json": [
		33031,
		33031
	],
	"./fr-TD/territories.json": [
		42131,
		42131
	],
	"./fr-TG/territories.json": [
		88046,
		88046
	],
	"./fr-TN/territories.json": [
		3417,
		3417
	],
	"./fr-VU/territories.json": [
		43874,
		43874
	],
	"./fr-WF/territories.json": [
		72226,
		72226
	],
	"./fr-YT/territories.json": [
		73102,
		73102
	],
	"./fr/territories.json": [
		850,
		850
	],
	"./fur/territories.json": [
		17893,
		17893
	],
	"./fy/territories.json": [
		91215,
		91215
	],
	"./ga-GB/territories.json": [
		30102,
		30102
	],
	"./ga/territories.json": [
		56146,
		56146
	],
	"./gd/territories.json": [
		76153,
		76153
	],
	"./gl/territories.json": [
		48049,
		48049
	],
	"./gsw-FR/territories.json": [
		14332,
		14332
	],
	"./gsw-LI/territories.json": [
		23079,
		23079
	],
	"./gsw/territories.json": [
		75299,
		75299
	],
	"./gu/territories.json": [
		27366,
		27366
	],
	"./guz/territories.json": [
		45414,
		45414
	],
	"./gv/territories.json": [
		19819,
		19819
	],
	"./ha-GH/territories.json": [
		49089,
		49089
	],
	"./ha-NE/territories.json": [
		53711,
		53711
	],
	"./ha/territories.json": [
		80001,
		80001
	],
	"./haw/territories.json": [
		38612,
		38612
	],
	"./he/territories.json": [
		66477,
		66477
	],
	"./hi-Latn/territories.json": [
		40563,
		40563
	],
	"./hi/territories.json": [
		55817,
		55817
	],
	"./hnj-Hmnp/territories.json": [
		84536,
		84536
	],
	"./hnj/territories.json": [
		78676,
		78676
	],
	"./hr-BA/territories.json": [
		22696,
		22696
	],
	"./hr/territories.json": [
		16,
		16
	],
	"./hsb/territories.json": [
		53149,
		53149
	],
	"./hu/territories.json": [
		69821,
		69821
	],
	"./hy/territories.json": [
		32697,
		32697
	],
	"./ia/territories.json": [
		6892,
		6892
	],
	"./id/territories.json": [
		10355,
		10355
	],
	"./ie/territories.json": [
		55312,
		55312
	],
	"./ig/territories.json": [
		72622,
		72622
	],
	"./ii/territories.json": [
		1588,
		1588
	],
	"./is/territories.json": [
		13882,
		13882
	],
	"./it-CH/territories.json": [
		96111,
		96111
	],
	"./it-SM/territories.json": [
		33920,
		33920
	],
	"./it-VA/territories.json": [
		47533,
		47533
	],
	"./it/territories.json": [
		99939,
		99939
	],
	"./ja/territories.json": [
		60459,
		60459
	],
	"./jgo/territories.json": [
		85984,
		85984
	],
	"./jmc/territories.json": [
		83726,
		83726
	],
	"./jv/territories.json": [
		36434,
		36434
	],
	"./ka/territories.json": [
		42102,
		42102
	],
	"./kab/territories.json": [
		28606,
		28606
	],
	"./kam/territories.json": [
		10375,
		10375
	],
	"./kde/territories.json": [
		48342,
		48342
	],
	"./kea/territories.json": [
		86311,
		86311
	],
	"./kgp/territories.json": [
		47146,
		47146
	],
	"./khq/territories.json": [
		30502,
		30502
	],
	"./ki/territories.json": [
		45998,
		45998
	],
	"./kk/territories.json": [
		94768,
		94768
	],
	"./kkj/territories.json": [
		96168,
		96168
	],
	"./kl/territories.json": [
		54013,
		54013
	],
	"./kln/territories.json": [
		5771,
		5771
	],
	"./km/territories.json": [
		13226,
		13226
	],
	"./kn/territories.json": [
		62863,
		62863
	],
	"./ko-CN/territories.json": [
		10236,
		10236
	],
	"./ko-KP/territories.json": [
		99294,
		99294
	],
	"./ko/territories.json": [
		20940,
		20940
	],
	"./kok/territories.json": [
		23775,
		23775
	],
	"./ks-Arab/territories.json": [
		91633,
		91633
	],
	"./ks-Deva/territories.json": [
		95843,
		95843
	],
	"./ks/territories.json": [
		32456,
		32456
	],
	"./ksb/territories.json": [
		86984,
		86984
	],
	"./ksf/territories.json": [
		84644,
		84644
	],
	"./ksh/territories.json": [
		77790,
		77790
	],
	"./ku/territories.json": [
		86562,
		86562
	],
	"./kw/territories.json": [
		55940,
		55940
	],
	"./kxv-Deva/territories.json": [
		68698,
		68698
	],
	"./kxv-Latn/territories.json": [
		41217,
		41217
	],
	"./kxv-Orya/territories.json": [
		79527,
		79527
	],
	"./kxv-Telu/territories.json": [
		71876,
		71876
	],
	"./kxv/territories.json": [
		88759,
		88759
	],
	"./ky/territories.json": [
		76670,
		76670
	],
	"./lag/territories.json": [
		13096,
		13096
	],
	"./lb/territories.json": [
		11012,
		11012
	],
	"./lg/territories.json": [
		3563,
		3563
	],
	"./lij/territories.json": [
		61815,
		61815
	],
	"./lkt/territories.json": [
		68895,
		68895
	],
	"./lmo/territories.json": [
		62556,
		62556
	],
	"./ln-AO/territories.json": [
		66337,
		88718
	],
	"./ln-CF/territories.json": [
		32608,
		32608
	],
	"./ln-CG/territories.json": [
		995,
		995
	],
	"./ln/territories.json": [
		63296,
		63296
	],
	"./lo/territories.json": [
		31683,
		31683
	],
	"./lrc-IQ/territories.json": [
		20754,
		20754
	],
	"./lrc/territories.json": [
		81439,
		81439
	],
	"./lt/territories.json": [
		7926,
		7926
	],
	"./lu/territories.json": [
		20953,
		20953
	],
	"./luo/territories.json": [
		73428,
		73428
	],
	"./luy/territories.json": [
		71526,
		71526
	],
	"./lv/territories.json": [
		83192,
		83192
	],
	"./mai/territories.json": [
		46425,
		46425
	],
	"./mas-TZ/territories.json": [
		87498,
		87498
	],
	"./mas/territories.json": [
		42019,
		42019
	],
	"./mer/territories.json": [
		8388,
		8388
	],
	"./mfe/territories.json": [
		25134,
		25134
	],
	"./mg/territories.json": [
		20314,
		20314
	],
	"./mgh/territories.json": [
		49636,
		27255
	],
	"./mgo/territories.json": [
		91977,
		91977
	],
	"./mi/territories.json": [
		84520,
		84520
	],
	"./mk/territories.json": [
		8838,
		8838
	],
	"./ml/territories.json": [
		26471,
		26471
	],
	"./mn-Mong-MN/territories.json": [
		65749,
		65749
	],
	"./mn/territories.json": [
		8661,
		8661
	],
	"./mni-Beng/territories.json": [
		86137,
		86137
	],
	"./mni/territories.json": [
		98618,
		98618
	],
	"./mr/territories.json": [
		41777,
		41777
	],
	"./ms-BN/territories.json": [
		51599,
		51599
	],
	"./ms-ID/territories.json": [
		55826,
		55826
	],
	"./ms-SG/territories.json": [
		45861,
		45861
	],
	"./ms/territories.json": [
		61998,
		61998
	],
	"./mt/territories.json": [
		40047,
		40047
	],
	"./mua/territories.json": [
		92501,
		92501
	],
	"./mus/territories.json": [
		26967,
		26967
	],
	"./my/territories.json": [
		6872,
		6872
	],
	"./mzn/territories.json": [
		21047,
		21047
	],
	"./naq/territories.json": [
		17936,
		17936
	],
	"./nb-SJ/territories.json": [
		58874,
		58874
	],
	"./nb/territories.json": [
		56682,
		56682
	],
	"./nd/territories.json": [
		28208,
		28208
	],
	"./nds-NL/territories.json": [
		60830,
		60830
	],
	"./nds/territories.json": [
		89235,
		89235
	],
	"./ne-IN/territories.json": [
		91407,
		91407
	],
	"./ne/territories.json": [
		98099,
		98099
	],
	"./nl-AW/territories.json": [
		5105,
		5105
	],
	"./nl-BE/territories.json": [
		87404,
		87404
	],
	"./nl-BQ/territories.json": [
		55360,
		55360
	],
	"./nl-CW/territories.json": [
		70379,
		70379
	],
	"./nl-SR/territories.json": [
		21620,
		21620
	],
	"./nl-SX/territories.json": [
		99818,
		99818
	],
	"./nl/territories.json": [
		62168,
		62168
	],
	"./nmg/territories.json": [
		42598,
		42598
	],
	"./nn/territories.json": [
		62102,
		62102
	],
	"./nnh/territories.json": [
		33384,
		33384
	],
	"./no/territories.json": [
		99961,
		99961
	],
	"./nqo/territories.json": [
		72402,
		72402
	],
	"./nso/territories.json": [
		37272,
		37272
	],
	"./nus/territories.json": [
		9450,
		9450
	],
	"./nyn/territories.json": [
		22509,
		22509
	],
	"./oc-ES/territories.json": [
		79845,
		79845
	],
	"./oc/territories.json": [
		40028,
		40028
	],
	"./om-KE/territories.json": [
		99687,
		99687
	],
	"./om/territories.json": [
		77990,
		77990
	],
	"./or/territories.json": [
		97135,
		19516
	],
	"./os-RU/territories.json": [
		49592,
		49592
	],
	"./os/territories.json": [
		45676,
		45676
	],
	"./osa/territories.json": [
		86389,
		86389
	],
	"./pa-Arab/territories.json": [
		54006,
		54006
	],
	"./pa-Guru/territories.json": [
		99427,
		99427
	],
	"./pa/territories.json": [
		25289,
		25289
	],
	"./pap-AW/territories.json": [
		3754,
		3754
	],
	"./pap/territories.json": [
		82193,
		82193
	],
	"./pcm/territories.json": [
		18832,
		18832
	],
	"./pis/territories.json": [
		29528,
		29528
	],
	"./pl/territories.json": [
		87450,
		87450
	],
	"./prg/territories.json": [
		74743,
		74743
	],
	"./ps-PK/territories.json": [
		10161,
		10161
	],
	"./ps/territories.json": [
		64443,
		64443
	],
	"./pt-AO/territories.json": [
		40051,
		40051
	],
	"./pt-CH/territories.json": [
		97732,
		97732
	],
	"./pt-CV/territories.json": [
		71438,
		71438
	],
	"./pt-GQ/territories.json": [
		39499,
		39499
	],
	"./pt-GW/territories.json": [
		31317,
		31317
	],
	"./pt-LU/territories.json": [
		18056,
		18056
	],
	"./pt-MO/territories.json": [
		81887,
		81887
	],
	"./pt-MZ/territories.json": [
		18288,
		18288
	],
	"./pt-PT/territories.json": [
		54191,
		54191
	],
	"./pt-ST/territories.json": [
		7456,
		7456
	],
	"./pt-TL/territories.json": [
		43771,
		43771
	],
	"./pt/territories.json": [
		32722,
		32722
	],
	"./qu-BO/territories.json": [
		41685,
		64066
	],
	"./qu-EC/territories.json": [
		41417,
		41417
	],
	"./qu/territories.json": [
		6952,
		6952
	],
	"./quc/territories.json": [
		93963,
		93963
	],
	"./raj/territories.json": [
		93477,
		93477
	],
	"./rm/territories.json": [
		47511,
		47511
	],
	"./rn/territories.json": [
		57554,
		57554
	],
	"./ro-MD/territories.json": [
		37327,
		37327
	],
	"./ro/territories.json": [
		92325,
		92325
	],
	"./rof/territories.json": [
		66523,
		66523
	],
	"./ru-BY/territories.json": [
		78541,
		78541
	],
	"./ru-KG/territories.json": [
		66306,
		66306
	],
	"./ru-KZ/territories.json": [
		85393,
		85393
	],
	"./ru-MD/territories.json": [
		75981,
		75981
	],
	"./ru-UA/territories.json": [
		12086,
		12086
	],
	"./ru/territories.json": [
		24831,
		24831
	],
	"./rw/territories.json": [
		27693,
		27693
	],
	"./rwk/territories.json": [
		56692,
		56692
	],
	"./sa/territories.json": [
		10942,
		10942
	],
	"./sah/territories.json": [
		60355,
		82736
	],
	"./saq/territories.json": [
		75083,
		75083
	],
	"./sat-Olck/territories.json": [
		87472,
		87472
	],
	"./sat/territories.json": [
		92004,
		92004
	],
	"./sbp/territories.json": [
		94575,
		94575
	],
	"./sc/territories.json": [
		5984,
		5984
	],
	"./sd-Arab/territories.json": [
		28890,
		28890
	],
	"./sd-Deva/territories.json": [
		74352,
		74352
	],
	"./sd/territories.json": [
		79629,
		79629
	],
	"./se-FI/territories.json": [
		83222,
		83222
	],
	"./se-SE/territories.json": [
		31227,
		31227
	],
	"./se/territories.json": [
		57946,
		57946
	],
	"./seh/territories.json": [
		87972,
		87972
	],
	"./ses/territories.json": [
		18877,
		18877
	],
	"./sg/territories.json": [
		88028,
		88028
	],
	"./shi-Latn/territories.json": [
		32006,
		32006
	],
	"./shi-Tfng/territories.json": [
		16734,
		16734
	],
	"./shi/territories.json": [
		27270,
		27270
	],
	"./shn-TH/territories.json": [
		66520,
		66520
	],
	"./shn/territories.json": [
		60455,
		60455
	],
	"./si/territories.json": [
		45798,
		45798
	],
	"./sk/territories.json": [
		83080,
		83080
	],
	"./sl/territories.json": [
		60373,
		60373
	],
	"./smn/territories.json": [
		58766,
		58766
	],
	"./sn/territories.json": [
		78983,
		78983
	],
	"./so-DJ/territories.json": [
		967,
		967
	],
	"./so-ET/territories.json": [
		18304,
		18304
	],
	"./so-KE/territories.json": [
		48773,
		48773
	],
	"./so/territories.json": [
		6564,
		6564
	],
	"./sq-MK/territories.json": [
		23943,
		23943
	],
	"./sq-XK/territories.json": [
		37162,
		37162
	],
	"./sq/territories.json": [
		80270,
		80270
	],
	"./sr-Cyrl-BA/territories.json": [
		75886,
		75886
	],
	"./sr-Cyrl-ME/territories.json": [
		13129,
		13129
	],
	"./sr-Cyrl-XK/territories.json": [
		61666,
		61666
	],
	"./sr-Cyrl/territories.json": [
		62342,
		62342
	],
	"./sr-Latn-BA/territories.json": [
		31811,
		31811
	],
	"./sr-Latn-ME/territories.json": [
		8636,
		8636
	],
	"./sr-Latn-XK/territories.json": [
		25275,
		25275
	],
	"./sr-Latn/territories.json": [
		43989,
		43989
	],
	"./sr/territories.json": [
		36243,
		36243
	],
	"./ss-SZ/territories.json": [
		49716,
		49716
	],
	"./ss/territories.json": [
		29040,
		29040
	],
	"./su-Latn/territories.json": [
		20901,
		43282
	],
	"./su/territories.json": [
		63850,
		63850
	],
	"./sv-AX/territories.json": [
		96997,
		96997
	],
	"./sv-FI/territories.json": [
		65289,
		65289
	],
	"./sv/territories.json": [
		19516,
		97135
	],
	"./sw-CD/territories.json": [
		31010,
		31010
	],
	"./sw-KE/territories.json": [
		58333,
		58333
	],
	"./sw-UG/territories.json": [
		3689,
		3689
	],
	"./sw/territories.json": [
		71564,
		71564
	],
	"./syr-SY/territories.json": [
		51747,
		51747
	],
	"./syr/territories.json": [
		36334,
		36334
	],
	"./szl/territories.json": [
		81072,
		81072
	],
	"./ta-LK/territories.json": [
		62823,
		62823
	],
	"./ta-MY/territories.json": [
		90528,
		90528
	],
	"./ta-SG/territories.json": [
		92228,
		92228
	],
	"./ta/territories.json": [
		43581,
		43581
	],
	"./te/territories.json": [
		113,
		113
	],
	"./teo-KE/territories.json": [
		81597,
		81597
	],
	"./teo/territories.json": [
		11852,
		11852
	],
	"./tg/territories.json": [
		7891,
		7891
	],
	"./th/territories.json": [
		97650,
		97650
	],
	"./ti-ER/territories.json": [
		21657,
		21657
	],
	"./ti/territories.json": [
		26789,
		26789
	],
	"./tk/territories.json": [
		89911,
		89911
	],
	"./tn-BW/territories.json": [
		96762,
		96762
	],
	"./tn/territories.json": [
		96408,
		96408
	],
	"./to/territories.json": [
		45243,
		45243
	],
	"./tok/territories.json": [
		20666,
		98285
	],
	"./tpi/territories.json": [
		6311,
		6311
	],
	"./tr-CY/territories.json": [
		83681,
		83681
	],
	"./tr/territories.json": [
		43324,
		43324
	],
	"./tt/territories.json": [
		66238,
		66238
	],
	"./twq/territories.json": [
		45836,
		45836
	],
	"./tzm/territories.json": [
		41721,
		41721
	],
	"./ug/territories.json": [
		23330,
		23330
	],
	"./uk/territories.json": [
		60414,
		60414
	],
	"./ur-IN/territories.json": [
		54277,
		54277
	],
	"./ur/territories.json": [
		26873,
		26873
	],
	"./uz-Arab/territories.json": [
		57310,
		57310
	],
	"./uz-Cyrl/territories.json": [
		50080,
		50080
	],
	"./uz-Latn/territories.json": [
		67067,
		67067
	],
	"./uz/territories.json": [
		11249,
		11249
	],
	"./vai-Latn/territories.json": [
		53520,
		53520
	],
	"./vai-Vaii/territories.json": [
		98186,
		98186
	],
	"./vai/territories.json": [
		5456,
		5456
	],
	"./vec/territories.json": [
		89826,
		89826
	],
	"./vi/territories.json": [
		27503,
		27503
	],
	"./vmw/territories.json": [
		22302,
		22302
	],
	"./vun/territories.json": [
		66737,
		66737
	],
	"./wae/territories.json": [
		35611,
		35611
	],
	"./wo/territories.json": [
		43744,
		43744
	],
	"./xh/territories.json": [
		80982,
		80982
	],
	"./xnr/territories.json": [
		80204,
		80204
	],
	"./xog/territories.json": [
		96594,
		96594
	],
	"./yav/territories.json": [
		45992,
		45992
	],
	"./yi/territories.json": [
		38884,
		38884
	],
	"./yo-BJ/territories.json": [
		87035,
		87035
	],
	"./yo/territories.json": [
		65542,
		65542
	],
	"./yrl-CO/territories.json": [
		97424,
		97424
	],
	"./yrl-VE/territories.json": [
		38607,
		38607
	],
	"./yrl/territories.json": [
		66153,
		66153
	],
	"./yue-Hans/territories.json": [
		16118,
		16118
	],
	"./yue-Hant/territories.json": [
		38007,
		38007
	],
	"./yue/territories.json": [
		8269,
		8269
	],
	"./za/territories.json": [
		25659,
		25659
	],
	"./zgh/territories.json": [
		96893,
		96893
	],
	"./zh-Hans-HK/territories.json": [
		47207,
		47207
	],
	"./zh-Hans-MO/territories.json": [
		88305,
		10686
	],
	"./zh-Hans-SG/territories.json": [
		816,
		816
	],
	"./zh-Hans/territories.json": [
		10321,
		10321
	],
	"./zh-Hant-HK/territories.json": [
		70208,
		70208
	],
	"./zh-Hant-MO/territories.json": [
		56809,
		56809
	],
	"./zh-Hant/territories.json": [
		66764,
		66764
	],
	"./zh/territories.json": [
		1264,
		1264
	],
	"./zu/territories.json": [
		77204,
		54823
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 30993;
module.exports = webpackAsyncContext;